import React from 'react';
import PropTypes from 'prop-types';
import {Button, Stack, Typography} from '@mui/material';
import {WorkbookPageHeader} from './WorkbookPageHeader';
import {TriangleAlertIcon} from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false, error: null};
  }

  static getDerivedStateFromError(error) {
    return {hasError: true, error};
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <WorkbookPageHeader title="Cash Flow Workbook"></WorkbookPageHeader>
          <Stack
            width="100%"
            height="100%"
            justifyContent="center"
            alignItems="center"
          >
            <TriangleAlertIcon style={{marginBottom: 24}} size={60} />
            <Typography
              mb={1}
              sx={{fontWeight: 600, fontSize: 24, color: '#162523'}}
            >
              Something went wrong
            </Typography>
            <Typography
              mb={3}
              sx={{fontSize: 16, fontWeight: 500, color: '#162523'}}
            >
              There’s an error when loading the workbook..
            </Typography>
            <Stack gap={2} direction="row">
              <Button
                variant="contained"
                color="green"
                onClick={() => {
                  window.location.reload();
                }}
              >
                Try Again
              </Button>
              <Button
                variant="outlined"
                component="a"
                href="mailto:support@inscopehq.com"
              >
                Contact Support
              </Button>
            </Stack>
          </Stack>
        </>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.any,
};

export default ErrorBoundary;
